import { newE2EPage } from '@stencil/core/testing';

describe('legrandav-chat-component', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<legrandav-chat-component></legrandav-chat-component>');

    const element = await page.find('legrandav-chat-component');
    expect(element).toHaveClass('hydrated');
  });
});
